import { API } from 'aws-amplify';

export const getPublicClientConfig = async (clientId, ref) => {
  const payload = { body: { clientId, ref } };
  const config = await API.post('GetTrustStartPublicConfigWithCreds', '/', payload);
  return config;
};

export const findScoringRequest = async (body) => {
  const payload = { body: { ...body } };
  const result = await API.post('TrustStartFindScoringRequest', '/', payload);
  return result;
};

export const dealerIbvRequest = async (body) => {
  const payload = { body: { ...body } };
  const result = await API.post('TrustStartDealerIbvRequest', '/', payload);
  return result;
};

export const getTrustStartStatus = async (requestId, integration, timestamp) => {
  const payload = { body: { pathParameters: { requestId, integration, timestamp } } };
  const result = await API.post('TrustStartStatus', '/', payload);
  return result;
};

export const createPrefill = (ref, phone) => {
  const payload = { body: { ref, create: { phone } } };
  return API.post('SmartConsentPrefill', '/', payload);
};

export const updatePrefill = (ref, id, updatedValues) => {
  const payload = { body: { ref, update: { ...updatedValues, id } } };
  return API.post('SmartConsentPrefill', '/', payload);
};

export const updateLeadApplication = (key, form, action) => {
  const payload = { body: { key, action, form } };
  return API.post('SmartConsentLeads', '/', payload);
};

export const viewOffer = (ref, requestId) => {
  const payload = { body: { ref, requestId, action: 'view' } };
  return API.post('SmartConsentOffers', '/', payload);
};

export const acceptOffer = (ref, requestId) => {
  const payload = { body: { ref, requestId, action: 'accept' } };
  return API.post('SmartConsentOffers', '/', payload);
};

export const declineOffer = (ref, requestId) => {
  const payload = { body: { ref, requestId, action: 'decline' } };
  return API.post('SmartConsentOffers', '/', payload);
};

export const storeBankingEvents = (event) => {
  const payload = { body: { ...event } };
  return API.post('StoreBankingEvents', '/', payload);
};

export const getDataProviderList = () => (API.post('DataProviderList', '/'));

export const getConsent = (clientId, requestId, provider) => (
  API.post('Consent', '/', {
    body: {
      clientId,
      requestId,
      provider,
      action: 'get',
    },
  })
);
